import {useDispatch, useSelector} from "react-redux";
import {select} from "application/store";
import {useCallback} from "react";
import {service} from "infrastructure/index";
import {isSuccessResponse, LoadingHelper} from "presentation/common";
import {toastHelper} from "presentation/common/helpers/toast";
import {useHistory} from "react-router-dom";
import {AppRoutes} from "application/index";
import {toReduxStore} from "./profile.adapter";

export const UseProfile = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const state = useSelector(
    select((models) => ({
      userInfo: models.auth.user,
      isAuthenticated: models.auth.isAuthenticated
    }))
  );

  const onUpdate = useCallback(async formValues => {
    const values = {...formValues, unique_id: state.userInfo.unique_id}
    LoadingHelper.open();

    try {
      const response = await service.updateProfile(values);

      if (isSuccessResponse(response)) {
        dispatch.auth.updateProfileAction(toReduxStore(values))
        toastHelper.success('Sus datos fueron actualizados correctamente.');
        history.replace(AppRoutes.home);
        return;
      }

      toastHelper.showGenericErrorMessage();
    } finally {
      LoadingHelper.close();
      await service.saveMarketingData(formValues);
    }
  }, []);

  return {...state, onUpdate}
}
